/* Hellbound Waifus — NSFW gate. Nav toggle + per-card reveal, remembered in localStorage. */
(function () {
  var KEY = 'hw-nsfw-opt-in';
  function on() { try { return localStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function apply() { document.body.classList.toggle('hw-nsfw-on', on()); sync(); }
  function sync() {
    var global = on();
    document.querySelectorAll('[data-hw-nsfw]').forEach(function (el) {
      if (global || el.dataset.hwRevealed === '1') el.classList.remove('hw-nsfw');
      else el.classList.add('hw-nsfw');
    });
    document.querySelectorAll('.hw-nsfw-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', String(global));
      var l = b.querySelector('[data-hw-label]');
      if (l) l.textContent = global ? 'on' : 'off';
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.hw-nsfw-toggle');
    if (t) {
      e.preventDefault();
      try { localStorage.setItem(KEY, on() ? '0' : '1'); } catch (err) {}
      apply();
      return;
    }
    var v = e.target.closest('[data-hw-nsfw].hw-nsfw');
    if (v) { e.preventDefault(); v.dataset.hwRevealed = '1'; sync(); }
  });
  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('shopify:section:load', sync);
  apply();
})();
